import homeAnim from "./home";
import labelAnim from "./label";
import menuAnim from "./menu-anim";
import prodAnim from "./prod";

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function (event) {
  console.log("DOM loaded");
  

  //wait until images, links, fonts, stylesheets, and js is loaded
/*   window.addEventListener(
    "load",

    () => {
    */
      menuAnim.init();

      let homepage = document.querySelector("#homepage");
      if (homepage !== null) {
        homeAnim.init();
        
      }

      let mentionspage = document.querySelector("#mentions");
      if (mentionspage !== null) {
        /* END OF PAGE ANIMATION */

        gsap.to(".section-mentions", {
          scrollTrigger: {
            trigger: "footer",
            start: "top bottom",
            scrub: true,
            end: "+=100%",
            markers: false,
          },
          width: "98%",
        });
      }

      let labelpage = document.querySelector("#label");
      if (labelpage !== null) {
        labelAnim.init();
      }

      let prodpage = document.querySelector("#production");
      if (prodpage !== null) {
        //menuAnim.init();
        prodAnim.init();
      }




      console.log("window loaded");
    }/* ,
    false
  ); */
/* }); */

  );